<template>
  <!-- start::component container -->
  <div id="page-user-list">
    <!-- start::filters -->
    <validation-observer v-slot="{ invalid }">
      <form>
        <vx-card ref="filterCard" title="Φίλτρα" class="user-list-filters mb-8" collapseAction refreshContentAction
          @refresh="resetColFilters" isContentCollapsed="true">
          <!-- start::filters row -->
          <div class="vx-row">

            <!-- start::filter date -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <validation-provider rules="required" v-slot="{errors}">
                <label class="text-sm opacity-75">Ημερομηνία</label>
                <flat-pickr v-model="date" :config="{ dateFormat: 'd F Y', maxDate: new Date(), }"
                  @input="findCrawlingSetsPerDate" class="w-full" name="date" placeholer="Επιλέξτε ημερομηνία" />
                <div class="text-right text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <!-- end::filter date -->

            <!-- start::filter time -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75">Ώρα</label>
              <v-select :options="hours" label="hours" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="selectedHour" class="mb-4 md:mb-0" />
            </div>
            <!-- end::filter time -->

            <!-- start::filter eshops -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75">Πηγή</label>
              <v-select :options="eshops" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="selectedEshop" class="mb-4 md:mb-0" />
            </div>
            <!-- end::filter eshops -->

            <!-- start::filter category -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75 customLabel">Κατηγορία
                <vs-button @click="selectedCategory = []" type="flat">Εκκαθάριση</vs-button>
                <br />
              </label>
              <v-select :options="categories" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                @input="getProductsByCategoryId()" v-model="selectedCategory" class="mb-4 md:mb-0" />
            </div>
            <!-- end::filter category -->

            <!-- start::filter products -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75 customLabel">Προϊόν
                <vs-button @click.prevent="selectedProduct = []" type="flat">Εκκαθάριση
                </vs-button>
              </label>
              <v-select :options="products" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="selectedProduct" class="mb-4 md:mb-0" />
            </div>
            <!-- end::filter products -->

            <!-- start::filter prices -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3">
              <label class="text-sm opacity-75">Τιμές</label>
              <v-select :options="filterOption" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="selectedFilter" />
            </div>
            <!-- end::filter prices -->

            <!-- start::action make report -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3 text-center">
              <vs-button :disabled="invalid" @click.prevent="generateReports(false)" color="primary" type="filled"
                class="ml-auto mt-6">
                Δημιουργία Report
              </vs-button>
            </div>
            <!-- end::action make report -->

            <!-- start::action generate xls -->
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-3 text-center">
              <vs-button :disabled="invalid" @click.prevent="generateReports(true)" color="primary" type="filled"
                class="ml-6 mt-6">
                Download Xls
              </vs-button>
            </div>
            <!-- end::action generate xls -->
          </div>
          <!-- end::filters row -->
        </vx-card>
      </form>
    </validation-observer>
    <!-- end::filters -->

    <!-- start::grid section -->
    <div class="vx-card p-6">
      <!-- start::first row wrapper -->
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer" style="display: none">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium
       ">
              <span class="mr-2">
                {{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
                -
                {{
                  recordsData.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : recordsData.length
                }}
                of {{ recordsData.length }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          " v-model="searchQuery" @input="updateSearchQuery" placeholder="Αναζήτηση..." />

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer" style="display: none">
          <div class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            ">
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- end::first row wrapper -->

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
        :floatingFilter="true" :pagination="false" :sideBar="sideBar" @grid-ready="onGridReady"
        :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" @column-moved="onColumnMoved" :excelStyles="excelStyles"
        @displayed-columns-changed="onColumnChangeStatus" :enableRtl="$vs.rtl">
      </ag-grid-vue>
    </div>
    <!-- end::grid section -->
  </div>
  <!-- end::component container -->
</template>

<script>
// Validation
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})

import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import 'ag-grid-enterprise'
import { LicenseManager } from 'ag-grid-enterprise'

// LicenseManager.setLicenseKey(
//   'For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-17_October_2020_[v2]_MTYwMjg4OTIwMDAwMA==10b84bf5b7eb0b92c717b40e1ae8f8ab'
// )

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererChecked from './cell-renderer/CellRendererChecked.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import axios from '@/axios'

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,

    // Validation
    ValidationObserver,
    ValidationProvider,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererChecked,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      selectedFilter: { label: 'Όλες οι τιμές', value: 'all' },
      filterOption: [
        { label: 'Όλες οι τιμές', value: 'all' },
        { label: 'Όλες οι χαμηλότερες τιμές', value: 'allLower' },
        { label: 'Μόνο χαμηλότερες τιμές', value: 'lowerOnly' },
      ],
      searchQuery: '',
      recordsData: [],
      date: null,
      hours: [],
      //eshops: [],
      //categories: [],
      //products: [],
      selectedHour: null,
      selectedEshop: null,
      selectedCategory: null,
      selectedProduct: null,
      columnState: '',
      excelStyles: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      columnApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: false,
      },
      sideBar: null,
      columnDefs: [
        {
          headerName: 'UID',
          field: 'product.remoteId',
          filter: 'agTextColumnFilter',
          width: 120,
          cellClass: 'stringType',
        },
        {
          headerName: 'MPN',
          field: 'product.part_number',
          filter: 'agTextColumnFilter',
          width: 120,
          cellClass: 'stringType',
        },
        {
          headerName: 'Όνομα Προϊόντος',
          field: 'product.name',
          filter: 'agTextColumnFilter',
          width: 325,
        },
        {
          headerName: 'Κατάστημα',
          field: 'eshop_partner',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Κατηγορία',
          field: 'product.category.name',
          filter: 'agSetColumnFilter',
          width: 150,
        },
        {
          headerName: 'Κατασκευαστής',
          field: 'product.manufacturer',
          filter: 'agTextColumnFilter',
          width: 170,
        },
        {
          headerName: 'Ομάδα',
          field: 'dealer.group.name',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Τιμή',
          field: 'product.erp_price',
          filter: 'agNumberColumnFilter',
          cellStyle: { 'text-align': 'right' },
          width: 150,
          valueFormatter: (params) => {
            if (
              params.data.product.erp_price === '' ||
              params.data.product.erp_price === undefined ||
              params.data.product.erp_price === null
            ) {
              return 0
            } else {
              return params.data.product.erp_price.toFixed(2)
            }
          },
        },
        {
          headerName: 'Τιμή με έκπτωση',
          field: 'product.promo_price',
          filter: 'agNumberColumnFilter',
          cellStyle: { 'text-align': 'right' },
          width: 150,
          valueFormatter: (params) => {
            if (
              params.data.product.promo_price === '' ||
              params.data.product.promo_price === undefined ||
              params.data.product.promo_price === null
            ) {
              return 0
            } else {
              return params.data.product.promo_price.toFixed(2)
            }
          },
        },
        {
          headerName: 'Τιμή Πηγής',
          filter: 'agNumberColumnFilter',
          width: 150,
          cellStyle: { 'text-align': 'right' },
          field: 'price_selling',
          valueFormatter: (params) => params.data.price_selling.toFixed(2),
          cellClass: function (params) {
            if (params.data.price_selling < params.data.product.erp_price) {
              return 'lessPrice'
            } else {
              return 'goodPrice'
            }
          },
        },
        {
          headerName: 'Ποσοστό',
          field: 'percent',
          filter: 'agNumberColumnFilter',
          width: 150,
          cellStyle: { 'text-align': 'right' },
          valueFormatter: (params) => {
            return params.data.percent.toFixed(2) + '%'
          },
        },
        {
          headerName: 'Ποσό',
          field: 'difference',
          filter: 'agNumberColumnFilter',
          width: 150,
          cellStyle: { 'text-align': 'right' },
          valueFormatter: (params) => {
            return params.data.difference.toFixed(2) + '€'
          },
        },
        {
          headerName: 'Flagged',
          field: 'dealer_status',
          filter: 'agTextColumnFilter',
          width: 150,
          cellRendererFramework: 'CellRendererVerified',
          cellClass: 'text-center',
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererChecked,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  computed: {
    eshops() {
      return this.$store.getters.getShops
    },
    categories() {
      return this.$store.getters.getSettingCategories
    },
    products() {
      return this.$store.getters.getProducts
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
  },
  methods: {
    findCrawlingSetsPerDate() {
      let vm = this
      let dateElements = vm.date.split(' ')
      let day = dateElements[0]
      let monthName = dateElements[1]
      let month = ''
      if (monthName === 'January') {
        month = '01'
      }
      if (monthName === 'February') {
        month = '02'
      }
      if (monthName === 'March') {
        month = '03'
      }
      if (monthName === 'April') {
        month = '04'
      }
      if (monthName === 'May') {
        month = '05'
      }
      if (monthName === 'June') {
        month = '06'
      }
      if (monthName === 'July') {
        month = '07'
      }
      if (monthName === 'August') {
        month = '08'
      }
      if (monthName === 'September') {
        month = '09'
      }
      if (monthName === 'October') {
        month = '10'
      }
      if (monthName === 'November') {
        month = '11'
      }
      if (monthName === 'December') {
        month = '12'
      }
      let year = dateElements[2]
      let dayDate = year + '-' + month + '-' + day
      vm.selectedHour = null
      axios
        .post('reports/findCrawlingSetsPerDate', { date: dayDate })
        .then((response) => {
          vm.hours = response.data.object
        })
    },
    getEshops() {
      this.$store.dispatch('fetchShops')
      // let vm = this
      // axios
      //   .get('eshops/list')
      //   .then((response) => {
      //     vm.eshops = response.data
      //     console.log(vm.eshops)
      //   })
      //   .catch((error) => {
      //     console.log(error)
      //   })
      //   .then((response) => {
      //     // alert('3)');
      //   })
    },
    getCategories() {
      this.$store.dispatch('fetchSettingCategories')
      // let vm = this
      // axios
      //   .get('productCategories/list')
      //   .then((response) => {
      //     vm.categories = response.data
      //   })
      //   .catch((error) => {
      //     console.log(error)
      //   })
      //   .then((response) => {
      //     // alert('3)');
      //   })
    },
    getProductsByCategoryId() {
      let vm = this
      vm.selectedProduct = null
      vm.$store.dispatch('fetchProductsByCategoryId', vm.selectedCategory.id)
      // axios
      //   .get(`products/listByCategoryId/${vm.selectedCategory.id}`)
      //   .then((response) => {
      //     vm.products = response.data
      //   })
      //   .catch((error) => {
      //     console.log(error)
      //   })
      //   .then((response) => {
      //     // alert('3)');
      //   })
    },
    generateReports(save = false) {
      let vm = this
      vm.$vs.loading()

      axios
        .post('reports/reportsByList' + (save ? '/save' : ''), {
          group_crawl: vm.selectedHour ? vm.selectedHour.uid : null,
          eshopId: vm.selectedEshop ? vm.selectedEshop.id : null,
          categoryId: vm.selectedCategory ? vm.selectedCategory.id : null,
          productId: vm.selectedProduct ? vm.selectedProduct.id : null,
          filter: vm.selectedFilter.value,
        })
        .then((response) => {
          vm.$vs.loading.close()
          if (save) {
            window.location.replace(response.data.object)
          } else {
            vm.recordsData = response.data
          }
        })
        .catch((error) => {
          //alert('unauthorized')
          vm.$vs.loading.close()
        })
        .then((response) => {
          // alert('3)');
          vm.$vs.loading.close()
        })
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.$refs.filterCard.removeRefreshAnimation()
      this.selectedHour = null
      this.selectedEshop = null
      this.selectedCategory = null
      this.selectedProduct = null
      this.date = ''
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    onColumnMoved(params) {
      this.columnState = JSON.stringify(params.columnApi.getColumnState())
      localStorage.setItem('myColumnState', this.columnState)
    },
    onColumnChangeStatus(params) {
      this.columnState = JSON.stringify(params.columnApi.getColumnState())
      localStorage.setItem('myColumnState', this.columnState)
      console.log(this.columnState)
    },
    onGridReady(params) {
      this.columnState = JSON.parse(localStorage.getItem('myColumnState'))
      if (this.columnState) {
        params.columnApi.setColumnState(this.columnState)
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
    this.gridColumnApi = this.gridOptions.columnApi
    this.columnState = JSON.parse(localStorage.getItem('myColumnState'))
    if (this.columnState) {
      this.gridColumnApi.setColumnState(this.columnState)
    }
  },
  created() {
    this.getEshops()
    this.getCategories()
    this.date = new Date()
  },
  beforeMount() {
    this.sideBar = {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Στήλες',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            suppressColumnFilter: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true,
          },
        },
      ],
    }
    this.excelStyles = [
      {
        id: 'booleanType',
        dataType: 'boolean',
      },
      {
        id: 'stringType',
        dataType: 'string',
      },
      {
        id: 'dateType',
        dataType: 'dateTime',
      },
      {
        id: 'lessPrice',
        interior: {
          color: '#FF0000',
          pattern: 'Solid',
        },
        font: {
          color: '#ffffff',
        },
      },
      {
        id: 'goodPrice',
        interior: {
          color: '#228B22',
          pattern: 'Solid',
        },
        font: {
          color: '#ffffff',
        },
      },
    ];
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.lessPrice {
  background: red;
  color: white;
}
.goodPrice {
  background: forestgreen;
  color: white;
}
.ag-theme-material .ag-side-bar {
  border-left: 1px solid rgba(var(--vs-primary), 1);
  padding-left: 10px;
}

.vs-button-primary.vs-button-flat {
  font-size: 9px;
  padding: 5px !important;
  float: right;
}

.customLabel {
  width: 100%;
  display: inline-block;
}
</style>
